import axios from 'axios';
import shaka from 'shaka-player';
import { epochConverter } from 'containers/Player/utils/epochConverter';

export const setLiveSubtitles = (subtitleLanguage, shakaPlayerRef) => {
  const subtitlesAreDisable = subtitleLanguage === 'disable';
  subtitlesAreDisable
    ? localStorage.removeItem('liveLanguageCaptions')
    : localStorage.setItem('liveLanguageCaptions', subtitleLanguage);
  if (!subtitlesAreDisable) {
    const textTracksFinded = shakaPlayerRef
      ?.getTextTracks()
      ?.find(caption => caption?.language === subtitleLanguage);
    shakaPlayerRef.selectTextLanguage(subtitleLanguage);
    shakaPlayerRef.selectTextTrack(textTracksFinded);
  }
  shakaPlayerRef.setTextTrackVisibility(!subtitlesAreDisable);
};

export const transformLiveSubtitles = (subtitlesResponse = '') => {
  try {
    //Constructores
    const decoder = new TextDecoder('utf-8');
    let parser = new DOMParser();

    //XML
    const subtitlesDecoded = decoder.decode(subtitlesResponse);
    const tagSplited = subtitlesDecoded.includes('<tt ') ? '<tt ' : '<?xml ';

    let subtitlesXML = parser.parseFromString(
      `${tagSplited}${subtitlesDecoded.split(tagSplited)[1]}`,
      'text/xml',
    );

    //DATOS OBTENIDOS DEL XML
    let timers = subtitlesXML.getElementsByTagName('div');
    let images = subtitlesXML.getElementsByTagName('smpte:image');
    let tracks = JSON.parse(sessionStorage.getItem('live-subs-tracks') || '[]');
    let newTracks = [];

    if (timers.length > 0) {
      for (let index = 0; index < timers.length; index++) {
        const timer = timers[index];
        if (timer.getAttribute('begin') && timer.getAttribute('end')) {
          newTracks.push({
            begin: epochConverter(timer.getAttribute('begin')),
            end: epochConverter(timer.getAttribute('end')),
            base64: images[index].textContent,
          });
        }
      }
      sessionStorage.setItem(
        'live-subs-tracks',
        JSON.stringify([...tracks, ...newTracks]),
      );
    }
  } catch (error) {
    console.log(error);
  }
};

// const transformVTTContent = (vttText, player) => {
//   const lines = vttText.split('\n');
//   let track = {};
//   const newTracks = [];
//   let tracks = JSON.parse(sessionStorage.getItem('live-subs-tracks') || '[]');

//   for (let i = 1; i < lines.length; i++) {
//     const line = lines[i].trim();

//     if (line.includes('-->')) {
//       const [startTime, endTime] = line.split(' --> ');
//       track = {
//         begin: epochConverter(startTime) + player.getMediaElement().currentTime,
//         end: epochConverter(endTime) + player.getMediaElement().currentTime,
//         text: '',
//       };
//     } else if (line !== '') {
//       track.text += line + '\n';
//     } else if (track?.text) {
//       track.text = track?.text.trim();
//       newTracks.push(track);
//       track = {};
//     }
//   }

//   sessionStorage.setItem(
//     'live-subs-tracks',
//     JSON.stringify([...tracks, ...newTracks]),
//   );
// };

// export const getLiveVTTContent = async (vttUrl, player) => {
//   try {
//     const { data } = await axios.get(vttUrl, { responseType: 'text' });
//     transformVTTContent(data, player);
//   } catch (error) {
//     console.log(error);
//   }
// };

const pad = (num, size = 2) => {
  let s = '000' + num;
  return s.substr(s.length - size);
};

const convertToSeconds = timeParts => {
  const [hours, minutes, seconds, milliseconds] = timeParts.map(Number);
  return hours * 3600 + minutes * 60 + seconds + milliseconds / 1000;
};

const formatTime = timeInSeconds => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  const milliseconds = Math.floor((timeInSeconds % 1) * 1000);
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}.${pad(
    milliseconds,
    3,
  )}`;
};

export const setResponseLiveSubtitles = (player, isLive, event) =>
  player
    .getNetworkingEngine()
    .registerResponseFilter(async function(type, response) {
      try {
        if (response?.uri.includes('.vtt') && isLive) {
          sessionStorage.setItem('subtitlesType', 'VTT');
          const textDecoder = new TextDecoder('utf-8');
          let vttText = textDecoder.decode(response.data);
          const beginTime = Date.now();

          const currentPlaybackTime =
            Date.now() / 1000 - Date.parse(event?.date_begin) / 1000;

          vttText = vttText.replace(
            /(\d{2}):(\d{2}):(\d{2})\.(\d{3}) --> (\d{2}):(\d{2}):(\d{2})\.(\d{3})/g,
            (match, ...groups) => {
              const endtime = Date.now();
              const offSetTime = endtime - beginTime;
              const startTime =
                epochConverter(
                  `${groups[0]}:${groups[1]}:${groups[2]}.${groups[3]}`,
                ) +
                currentPlaybackTime +
                offSetTime;
              const endTimeLast = Date.now();
              const secondOffSetTime = endTimeLast - beginTime;
              const endTime =
                epochConverter(
                  `${groups[4]}:${groups[5]}:${groups[6]}.${groups[7]}`,
                ) +
                currentPlaybackTime +
                secondOffSetTime;
              return `${formatTime(startTime)} --> ${formatTime(endTime)}`;
            },
          );
          const textEncoder = new TextEncoder();
          response.data = textEncoder.encode(vttText);
        }
      } catch (error) {
        console.log(error, 'ERR');
      }
    });
